import styled from '@emotion/styled';
import { palette } from 'Constants/Palette';

/**
 * Tipografía del contenido de noticias (heredada de MarkdownText): el HTML
 * sanitizado decide qué etiquetas aparecen, así que un wrapper con reglas por
 * etiqueta es más simple que mapear cada elemento a un styled component. Solo
 * se estilan las etiquetas del allowlist de RichText.
 */
export const Wrapper = styled.div`
  font-size: 14px;
  line-height: 1.55;
  color: ${palette.ink};
  overflow-wrap: break-word;

  p {
    margin: 0 0 12px;
  }

  strong {
    font-weight: 700; /* el * de GlobalStyle fuerza 400; el peso debe ser explícito */
  }

  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 22px;
  }

  li {
    margin-bottom: 4px;
  }

  a {
    color: ${palette.green};
    font-weight: 600;
    text-decoration: underline;

    &:hover {
      color: ${palette.ink};
    }
  }

  /* Escalado sobrio: es contenido de noticia, no landing. */
  h1,
  h2,
  h3 {
    margin: 16px 0 8px;
    color: ${palette.ink};
    font-weight: 700; /* el * de GlobalStyle fuerza 400; el peso debe ser explícito */
    line-height: 1.45;

    &:first-of-type {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 19px;
  }

  h2 {
    font-size: 17px;
  }

  h3 {
    font-size: 15px;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;
